// import "../../styles/UserDashboard/ListEnergy.scss";
// import SideBar from "../../components/UserDashboard/SideBar";
// import { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import EnergyHeader from "../../components/energy/energyHeader";
// import EnergyTransferred from "../../components/energy/EnergyTransferred";
// import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
// import { lgaList } from "../../data/nigerianStatesData";
// import { toast } from "react-toastify";
// import { useForm } from "react-hook-form";
// import { useSelector } from "react-redux";
// import EnergySharingContract from "../../Abi/EnergySharingContract.json";
// import Web3 from "web3";
// import { ethers } from "ethers";

// export default function EditListing() {
//   const auth = useSelector((state) => state.auth);
//   const [loading, setLoading] = useState(false);
//   const [web3, setWeb3] = useState(null);
//   const [account, setAccount] = useState(null);
//   const [listing, setListing] = useState(null);
//   const [priceRange, setPriceRange] = useState(null);
//   const [excessEnergyBalance, setExcessEnergyBalance] = useState(null);
//   const [open, setOpen] = useState(false);

//   const navigate = useNavigate();
//   const { id } = useParams();

//   const {
//     handleSubmit,
//     register,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm();

//   const states = Object.keys(lgaList).sort();
//   const watchRate = watch("rate");
//   const watchAmountTo = watch("amountTo");

//   // Initialize Web3
//   useEffect(() => {
//     if (window.ethereum) {
//       const web3Instance = new Web3(window.ethereum);
//       setWeb3(web3Instance);
//       window.ethereum
//         .request({ method: "eth_requestAccounts" })
//         .then((accounts) => setAccount(accounts[0]))
//         .catch((err) => {
//           console.error("User denied account access", err);
//         });
//     }
//   }, []);

//   // Fetch listing data and price range
//   useEffect(() => {
//     if (id && account) {
//       handleGetListing();
//       fetchPriceRange();
//       fetchExcessEnergyBalance();
//     }
//   }, [id, account]);

//   const fetchPriceRange = async () => {
//     try {
//       const integration = new EnergyTradingIntegration("seller");
//       await integration.init();
//       const range = await integration.getPlatformPriceRange();
//       console.log("Fetched platform price range from contract:", range);
//       setPriceRange(range);
//     } catch (e) {
//       console.error("Failed to fetch platform price range from contract:", e);
//     }
//   };

//   const fetchExcessEnergyBalance = async () => {
//     if (!account) return;
//     try {
//       const integration = new EnergyTradingIntegration("seller");
//       await integration.init();
//       const balance = await integration.getExcessEnergyBalance(account);
//       setExcessEnergyBalance(balance);
//       console.log("Excess Energy Balance:", balance);
//     } catch (error) {
//       console.error("Failed to fetch excess energy balance", error);
//     }
//   };

//   const handleGetListing = async () => {
//     try {
//       setLoading(true);
//       const integration = new EnergyTradingIntegration("seller");
//       await integration.init();

//       const response = await integration.getSellerListing(Number(id));
//       setListing(response);

//       console.log("Fetched listing data:", response);

//       // Pre-populate form with existing data
//       setValue("rate", response.pricePerUnit?.toString() || "");
//       setValue("amountTo", response.quantity?.toString() || "");
//       setValue("stateOfOrigin", ""); // You'll need to get this from backend
//       setValue("minQuantity", response.minPurchaseAmount?.toString() || "");
//       setValue("maxQuantity", response.maxPurchaseAmount?.toString() || "");
//       setValue("houseNumber", ""); // You'll need to get this from backend
//       setValue("address", response.location || ""); // Using location as address for now

//     } catch (error) {
//       console.error("Failed to get listing:", error);
//       toast.error(`Failed to load listing: ${error.message}`);
//       navigate("/energy-listing");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBack = () => {
//     navigate("/energy-listing");
//   };

//   const onSubmit = async (data) => {
//     console.log("Form data for update:", data);
//     setLoading(true);

//     try {
//       const integration = new EnergyTradingIntegration("seller");
//       await integration.init();

//       // Validation
//       if (Number(data.minQuantity) >= Number(data.maxQuantity)) {
//         toast.error("Minimum purchase amount must be less than maximum purchase amount");
//         setLoading(false);
//         return;
//       }

//       if (priceRange) {
//         const price = Number(data.rate);
//         if (price < priceRange.min || price > priceRange.max) {
//           toast.error(`Price must be between ₦${priceRange.min} and ₦${priceRange.max}`);
//           setLoading(false);
//           return;
//         }
//       }

//       // Update the listing on blockchain
//       await integration.updateListing(
//         Number(id),
//         Number(data.rate),
//         Number(data.minQuantity),
//         Number(data.maxQuantity)
//       );

//       console.log("Listing updated successfully");

//       // await updateBackendListing(id, data);

//       toast.success("Listing updated successfully!");
//       setOpen(true);

//     } catch (error) {
//       console.error("Failed to update listing:", error);
//       toast.error(`Failed to update listing: ${error.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading && !listing) {
//     return (
//       <div className="energyOverview">
//         <div className="sidebar_container">
//           <SideBar />
//         </div>
//         <div className="energyOverview__inner">
//           <EnergyHeader />
//           <div className="loading">Loading...</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="energyOverview">
//       <div className="sidebar_container">
//         <SideBar />
//       </div>
//       <div className="energyOverview__inner">
//         <EnergyHeader />
//         <div className="listEnergy__back" onClick={handleBack}>
//           <svg
//             width="24"
//             height="24"
//             viewBox="0 0 24 24"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M19.0004 11.0006H7.83041L12.7104 6.12065C13.1004 5.73065 13.1004 5.09065 12.7104 4.70065C12.6179 4.60794 12.508 4.5344 12.387 4.48421C12.2661 4.43403 12.1364 4.4082 12.0054 4.4082C11.8744 4.4082 11.7448 4.43403 11.6238 4.48421C11.5028 4.5344 11.3929 4.60794 11.3004 4.70065L4.71041 11.2906C4.61771 11.3832 4.54416 11.493 4.49398 11.614C4.4438 11.735 4.41797 11.8647 4.41797 11.9956C4.41797 12.1266 4.4438 12.2563 4.49398 12.3773C4.54416 12.4982 4.61771 12.6081 4.71041 12.7006L11.3004 19.2906C11.393 19.3832 11.5029 19.4567 11.6239 19.5068C11.7448 19.5569 11.8745 19.5827 12.0054 19.5827C12.1363 19.5827 12.266 19.5569 12.387 19.5068C12.5079 19.4567 12.6178 19.3832 12.7104 19.2906C12.803 19.1981 12.8764 19.0882 12.9265 18.9672C12.9766 18.8462 13.0024 18.7166 13.0024 18.5856C13.0024 18.4547 12.9766 18.3251 12.9265 18.2041C12.8764 18.0831 12.803 17.9732 12.7104 17.8806L7.83041 13.0006H19.0004C19.5504 13.0006 20.0004 12.5506 20.0004 12.0006C20.0004 11.4506 19.5504 11.0006 19.0004 11.0006Z"
//               fill="black"
//             />
//           </svg>
//           Back
//         </div>

//         <form className="listEnergy__form" onSubmit={handleSubmit(onSubmit)}>
//           {/* PRICE INPUT */}
//           <label className="listEnergy__form__label" htmlFor="rate">
//             At what rate (Price)
//             <span style={{ fontSize: 14, marginLeft: 8 }}>
//               {priceRange && (
//                 <span>(Allowed: ₦{priceRange.min} - ₦{priceRange.max} per kWh)</span>
//               )}
//             </span>
//           </label>
//           <div className="listEnergy__form__input">
//             <div className="listEnergy__form__input__unit">₦/kWh</div>
//             <input
//               type="number"
//               placeholder="0.00"
//               {...register("rate", {
//                 required: true,
//                 min: priceRange?.min ?? 0,
//                 max: priceRange?.max ?? Infinity,
//                 valueAsNumber: true,
//               })}
//             />
//           </div>

//           <div className="listEnergy__form__guide">
//             1.00 kWh = ₦{watchRate || 0}
//           </div>

//           {/* AMOUNT INPUT (Read-only) */}
//           <label className="listEnergy__form__label" htmlFor="">
//             <div>Amount to sell (Energy)</div>
//             <div>
//               Balance: <span>{excessEnergyBalance !== null ? excessEnergyBalance : "..."}kWh</span>
//             </div>
//           </label>
//           <div className="listEnergy__form__input">
//             <div className="listEnergy__form__input__unit">kWh</div>
//             <input
//               type="number"
//               placeholder="0.00"
//               {...register("amountTo")}
//               readOnly
//               className="read-only-input"
//             />
//           </div>
//           <div className="listEnergy__form__note">
//             Note: Total amount cannot be changed after creation
//           </div>

//           {/* LOCATION FIELDS (Read-only) */}
//           <div className="form-section">
//             <h3>Location Information</h3>
//             <p className="section-note">Location details cannot be modified after creation</p>
//           </div>

//           <div className="listEnergy__form__input-group">
//             <div>
//               <label className="listEnergy__form__label" htmlFor="">
//                 State
//               </label>
//               <select
//                 className="listEnergy__form__input"
//                 {...register("stateOfOrigin")}
//                 disabled
//               >
//                 <option value="">Select State</option>
//                 {states?.map((item) => (
//                   <option key={item} value={item}>{item}</option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="listEnergy__form__label" htmlFor="">
//                 House Number
//               </label>
//               <input
//                 type="text"
//                 placeholder="House Number"
//                 className="listEnergy__form__input"
//                 {...register("houseNumber")}
//                 disabled
//               />
//             </div>
//           </div>

//           <label className="listEnergy__form__label" htmlFor="">
//             Address
//           </label>
//           <input
//             type="text"
//             placeholder="Address"
//             className="listEnergy__form__input"
//             {...register("address")}
//             disabled
//           />

//           {/* QUANTITY LIMITS */}
//           <div className="listEnergy__form__input-group">
//             <div>
//               <label className="listEnergy__form__label" htmlFor="">
//                 Minimum Purchase Quantity
//               </label>
//               <div className="listEnergy__form__input">
//                 <div className="listEnergy__form__input__unit">kWh</div>
//                 <input
//                   type="number"
//                   placeholder="0.00"
//                   {...register("minQuantity", {
//                     required: true,
//                     min: 1,
//                     valueAsNumber: true,
//                   })}
//                 />
//               </div>
//             </div>
//             <div>
//               <label className="listEnergy__form__label" htmlFor="">
//                 Maximum Purchase Quantity
//               </label>
//               <div className="listEnergy__form__input">
//                 <div className="listEnergy__form__input__unit">kWh</div>
//                 <input
//                   type="number"
//                   placeholder="0.00"
//                   {...register("maxQuantity", {
//                     required: true,
//                     min: 1,
//                     valueAsNumber: true,
//                   })}
//                 />
//               </div>
//             </div>
//           </div>

//           <button
//             className="listEnergy__form__button"
//             type="submit"
//             disabled={loading}
//           >
//             {loading ? "Updating..." : "Save Changes"}
//           </button>
//         </form>
//       </div>

//       <EnergyTransferred
//         title="Changes Successful"
//         subtitle="Your listing has been updated successfully"
//         open={open}
//         setOpen={setOpen}
//         onConfirm={() => navigate("/energy-listing")}
//       />
//     </div>
//   );
// }


import "../../styles/UserDashboard/ListEnergy.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EnergyHeader from "../../components/energy/energyHeader";
import EnergyTransferred from "../../components/energy/EnergyTransferred";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { lgaList } from "../../data/nigerianStatesData";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";
import Web3 from "web3";
import { ethers } from "ethers";
import { getEnergyListedDetails, web2ListEnergySell } from "../../apis/energySharing";

export default function EditListing() {
  const auth = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [web3, setWeb3] = useState(null);
  const [account, setAccount] = useState(null);
  const [listing, setListing] = useState(null);
  const [priceRange, setPriceRange] = useState(null);
  const [excessEnergyBalance, setExcessEnergyBalance] = useState(null);
  const [open, setOpen] = useState(false);
  const [availableBalance, setAvailableBalance] = useState(0);

  const navigate = useNavigate();
  const { id } = useParams();

  const {
    handleSubmit,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const states = Object.keys(lgaList).sort();
  const watchRate = watch("rate");
  const watchAmountTo = watch("amountTo");
  const watchMinQuantity = watch("minQuantity");
  const watchMaxQuantity = watch("maxQuantity");

  // Initialize Web3
  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          console.error("User denied account access", err);
        });
    }
  }, []);

  // Fetch listing data, price range, and balance
  useEffect(() => {
    if (id && account) {
      handleGetListing();
      fetchPriceRange();
      fetchExcessEnergyBalance();
    }
  }, [id, account]);

  const fetchPriceRange = async () => {
    try {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();
      const range = await integration.getPlatformPriceRange();
      console.log("Fetched platform price range from contract:", range);
      setPriceRange(range);
    } catch (e) {
      console.error("Failed to fetch platform price range from contract:", e);
    }
  };

  const fetchExcessEnergyBalance = async () => {
    if (!account) return;
    try {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();
      const balance = await integration.getExcessEnergyBalance(account);
      setExcessEnergyBalance(balance);
      console.log("Excess Energy Balance:", balance);

      // Calculate available balance (excess + current listing amount)
      if (listing && listing.quantity) {
        const available = Number(balance) + Number(listing.quantity);
        setAvailableBalance(available);
      } else {
        setAvailableBalance(Number(balance));
      }
    } catch (error) {
      console.error("Failed to fetch excess energy balance", error);
    }
  };

  const handleGetListing = async () => {
    try {
      setLoading(true);

      // Fetch from backend using the correct function name
      const backendResponse = await getEnergyListedDetails(id, auth?.token);
      console.log("Backend listing data:", backendResponse);

      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      const blockchainResponse = await integration.getSellerListing(Number(id));

      // Combine both responses
      const combinedListing = {
        ...blockchainResponse,
        ...backendResponse.data,
        // Map backend fields to expected names if needed
        pricePerUnit: backendResponse.data?.rate || blockchainResponse.pricePerUnit,
        quantity: backendResponse.data?.amount || blockchainResponse.quantity,
        minPurchaseAmount: backendResponse.data?.range?.min || blockchainResponse.minPurchaseAmount,
        maxPurchaseAmount: backendResponse.data?.range?.max || blockchainResponse.maxPurchaseAmount
      };

      setListing(combinedListing);

      console.log("Fetched combined listing data:", combinedListing);

      // Pre-populate form with existing data from both sources
      setValue("rate", combinedListing.pricePerUnit?.toString() || "");
      setValue("amountTo", combinedListing.quantity?.toString() || "");
      setValue("stateOfOrigin", combinedListing.stateOfOrigin || "");
      setValue("minQuantity", combinedListing.minPurchaseAmount?.toString() || "");
      setValue("maxQuantity", combinedListing.maxPurchaseAmount?.toString() || "");
      setValue("houseNumber", combinedListing.houseNumber || "");
      setValue("address", combinedListing.address || combinedListing.location || "");

    } catch (error) {
      console.error("Failed to get listing:", error);
      toast.error(`Failed to load listing: ${error.message}`);
      navigate("/energy-listing");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/energy-listing");
  };

  // Function to update backend listing
  const updateBackendListing = async (listingId, data) => {
    try {
      // Use the same function as creating a sell listing but for update
      // You might need to create a separate update endpoint in your backend
      const response = await web2ListEnergySell(
        Number(listingId),
        Number(data.rate),
        Number(data.amountTo),
        data.stateOfOrigin,
        {
          min: Number(data.minQuantity),
          max: Number(data.maxQuantity)
        },
        data.houseNumber,
        data.address,
        auth?.token,
      );
      return response;
    } catch (error) {
      console.error("Failed to update backend:", error);
      throw error;
    }
  };

  const onSubmit = async (data) => {
    console.log("Form data for update:", data);
    setLoading(true);

    try {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();

      // Validation
      if (Number(data.minQuantity) >= Number(data.maxQuantity)) {
        toast.error("Minimum purchase amount must be less than maximum purchase amount");
        setLoading(false);
        return;
      }

      if (Number(data.maxQuantity) > Number(data.amountTo)) {
        toast.error("Maximum purchase amount cannot exceed total listing amount");
        setLoading(false);
        return;
      }

      if (priceRange) {
        const price = Number(data.rate);
        if (price < priceRange.min || price > priceRange.max) {
          toast.error(`Price must be between ₦${priceRange.min} and ₦${priceRange.max}`);
          setLoading(false);
          return;
        }
      }

      // Check if amount is being increased and validate against available balance
      const currentAmount = Number(listing.quantity);
      const newAmount = Number(data.amountTo);

      if (newAmount > currentAmount) {
        const amountIncrease = newAmount - currentAmount;
        if (amountIncrease > Number(excessEnergyBalance)) {
          toast.error(`Cannot increase amount by ${amountIncrease} kWh. Available balance: ${excessEnergyBalance} kWh`);
          setLoading(false);
          return;
        }
      }

      // Convert all values to numbers and ensure they are valid
      const listingId = Number(id);
      const newPricePerUnit = Number(data.rate);
      const newMinPurchaseAmount = Number(data.minQuantity);
      const newMaxPurchaseAmount = Number(data.maxQuantity);

      // Validate that all numbers are valid
      if (isNaN(listingId) || isNaN(newPricePerUnit) || isNaN(newMinPurchaseAmount) || isNaN(newMaxPurchaseAmount)) {
        toast.error("Invalid input values. Please check your entries.");
        setLoading(false);
        return;
      }

      console.log("Updating listing with parameters:", {
        listingId,
        newPricePerUnit,
        newMinPurchaseAmount,
        newMaxPurchaseAmount
      });

      // Update the listing on blockchain - ONLY 4 PARAMETERS as per function signature
      const blockchainResponse = await integration.updateListing(
        listingId,
        newPricePerUnit,
        newMinPurchaseAmount,
        newMaxPurchaseAmount
      );

      console.log("Blockchain update response:", blockchainResponse);

      // Update backend with all data
      const backendResponse = await updateBackendListing(
        id,
        {
          rate: newPricePerUnit,
          amount: newAmount,
          stateOfOrigin: data.stateOfOrigin,
          range: {
            min: newMinPurchaseAmount,
            max: newMaxPurchaseAmount
          },
          houseNumber: data.houseNumber,
          address: data.address
        }
      );

      console.log("Backend update response:", backendResponse);

      toast.success("Listing updated successfully!");

      // Refresh balance after successful update
      await fetchExcessEnergyBalance();

      setOpen(true);

    } catch (error) {
      console.error("Failed to update listing:", error);
      toast.error(`Failed to update listing: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading && !listing) {
    return (
      <div className="energyOverview">
        <div className="sidebar_container">
          <SideBar />
        </div>
        <div className="energyOverview__inner">
          <EnergyHeader />
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="energyOverview">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="energyOverview__inner">
        <EnergyHeader />
        <div className="listEnergy__back" onClick={handleBack}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.0004 11.0006H7.83041L12.7104 6.12065C13.1004 5.73065 13.1004 5.09065 12.7104 4.70065C12.6179 4.60794 12.508 4.5344 12.387 4.48421C12.2661 4.43403 12.1364 4.4082 12.0054 4.4082C11.8744 4.4082 11.7448 4.43403 11.6238 4.48421C11.5028 4.5344 11.3929 4.60794 11.3004 4.70065L4.71041 11.2906C4.61771 11.3832 4.54416 11.493 4.49398 11.614C4.4438 11.735 4.41797 11.8647 4.41797 11.9956C4.41797 12.1266 4.4438 12.2563 4.49398 12.3773C4.54416 12.4982 4.61771 12.6081 4.71041 12.7006L11.3004 19.2906C11.393 19.3832 11.5029 19.4567 11.6239 19.5068C11.7448 19.5569 11.8745 19.5827 12.0054 19.5827C12.1363 19.5827 12.266 19.5569 12.387 19.5068C12.5079 19.4567 12.6178 19.3832 12.7104 19.2906C12.803 19.1981 12.8764 19.0882 12.9265 18.9672C12.9766 18.8462 13.0024 18.7166 13.0024 18.5856C13.0024 18.4547 12.9766 18.3251 12.9265 18.2041C12.8764 18.0831 12.803 17.9732 12.7104 17.8806L7.83041 13.0006H19.0004C19.5504 13.0006 20.0004 12.5506 20.0004 12.0006C20.0004 11.4506 19.5504 11.0006 19.0004 11.0006Z"
              fill="black"
            />
          </svg>
          Back
        </div>

        <form className="listEnergy__form" onSubmit={handleSubmit(onSubmit)}>
          {/* PRICE INPUT */}
          <label className="listEnergy__form__label" htmlFor="rate">
            At what rate (Price)
            <span style={{ fontSize: 14, marginLeft: 8 }}>
              {priceRange && (
                <span>(Allowed: ₦{priceRange.min} - ₦{priceRange.max} per kWh)</span>
              )}
            </span>
          </label>
          <div className="listEnergy__form__input">
            <div className="listEnergy__form__input__unit">₦/kWh</div>
            <input
              type="number"
              placeholder="0.00"
              {...register("rate", {
                required: "Price is required",
                min: {
                  value: priceRange?.min ?? 0,
                  message: `Price must be at least ₦${priceRange?.min}`
                },
                max: {
                  value: priceRange?.max ?? Infinity,
                  message: `Price cannot exceed ₦${priceRange?.max}`
                },
                valueAsNumber: true,
              })}
            />
          </div>
          {errors.rate && (
            <div className="error-message">{errors.rate.message}</div>
          )}

          <div className="listEnergy__form__guide">
            1.00 kWh = ₦{watchRate || 0}
          </div>

          {/* AMOUNT INPUT (Editable) */}
          <label className="listEnergy__form__label" htmlFor="">
            <div>Amount to sell (Energy)</div>
            <div>
              Available Balance: <span>{availableBalance !== null ? availableBalance : "..."} kWh</span>
            </div>
          </label>
          <div className="listEnergy__form__input">
            <div className="listEnergy__form__input__unit">kWh</div>
            <input
              type="number"
              placeholder="0.00"
              {...register("amountTo", {
                required: "Amount is required",
                min: {
                  value: 1,
                  message: "Amount must be at least 1 kWh"
                },
                max: {
                  value: availableBalance,
                  message: `Amount cannot exceed available balance of ${availableBalance} kWh`
                },
                valueAsNumber: true,
              })}
            />
          </div>
          {errors.amountTo && (
            <div className="error-message">{errors.amountTo.message}</div>
          )}
          <div className="listEnergy__form__note">
            Note: You can adjust the amount up to your available balance
          </div>

          {/* LOCATION FIELDS (Editable) */}
          <div className="form-section">
            <h3>Location Information</h3>
          </div>

          <div className="listEnergy__form__input-group">
            <div>
              <label className="listEnergy__form__label" htmlFor="">
                State
              </label>
              <select
                className="listEnergy__form__input"
                {...register("stateOfOrigin", {
                  required: "State is required"
                })}
              >
                <option value="">Select State</option>
                {states?.map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
              {errors.stateOfOrigin && (
                <div className="error-message">{errors.stateOfOrigin.message}</div>
              )}
            </div>
            <div>
              <label className="listEnergy__form__label" htmlFor="">
                House Number
              </label>
              <input
                type="text"
                placeholder="House Number"
                className="listEnergy__form__input"
                {...register("houseNumber", {
                  required: "House number is required"
                })}
              />
              {errors.houseNumber && (
                <div className="error-message">{errors.houseNumber.message}</div>
              )}
            </div>
          </div>

          <label className="listEnergy__form__label" htmlFor="">
            Address
          </label>
          <input
            type="text"
            placeholder="Address"
            className="listEnergy__form__input"
            {...register("address", {
              required: "Address is required"
            })}
          />
          {errors.address && (
            <div className="error-message">{errors.address.message}</div>
          )}

          {/* QUANTITY LIMITS */}
          <div className="listEnergy__form__input-group">
            <div>
              <label className="listEnergy__form__label" htmlFor="">
                Minimum Purchase Quantity
              </label>
              <div className="listEnergy__form__input">
                <div className="listEnergy__form__input__unit">kWh</div>
                <input
                  type="number"
                  placeholder="0.00"
                  {...register("minQuantity", {
                    required: "Minimum quantity is required",
                    min: {
                      value: 1,
                      message: "Minimum must be at least 1 kWh"
                    },
                    valueAsNumber: true,
                  })}
                />
              </div>
              {errors.minQuantity && (
                <div className="error-message">{errors.minQuantity.message}</div>
              )}
            </div>
            <div>
              <label className="listEnergy__form__label" htmlFor="">
                Maximum Purchase Quantity
              </label>
              <div className="listEnergy__form__input">
                <div className="listEnergy__form__input__unit">kWh</div>
                <input
                  type="number"
                  placeholder="0.00"
                  {...register("maxQuantity", {
                    required: "Maximum quantity is required",
                    min: {
                      value: 1,
                      message: "Maximum must be at least 1 kWh"
                    },
                    valueAsNumber: true,
                  })}
                />
              </div>
              {errors.maxQuantity && (
                <div className="error-message">{errors.maxQuantity.message}</div>
              )}
            </div>
          </div>

          {/* Validation summary */}
          {watchMinQuantity && watchMaxQuantity && Number(watchMinQuantity) >= Number(watchMaxQuantity) && (
            <div className="error-message" style={{ marginBottom: '1rem' }}>
              Minimum purchase amount must be less than maximum purchase amount
            </div>
          )}

          {watchMaxQuantity && watchAmountTo && Number(watchMaxQuantity) > Number(watchAmountTo) && (
            <div className="error-message" style={{ marginBottom: '1rem' }}>
              Maximum purchase amount cannot exceed total listing amount
            </div>
          )}

          <button
            className="listEnergy__form__button"
            type="submit"
            disabled={loading ||
              Number(watchMinQuantity) >= Number(watchMaxQuantity) ||
              Number(watchMaxQuantity) > Number(watchAmountTo)
            }
          >
            {loading ? "Updating..." : "Save Changes"}
          </button>
        </form>
      </div>

      <EnergyTransferred
        title="Changes Successful"
        subtitle="Your listing has been updated successfully"
        open={open}
        setOpen={setOpen}
        onConfirm={() => navigate("/energy-listing")}
      />
    </div>
  );
}